import { render, staticRenderFns } from "./base-error.vue?vue&type=template&id=453278e2&"
import script from "./base-error.vue?vue&type=script&lang=js&"
export * from "./base-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports